import TemplateView from 'picnic/core/views/Template';
import Template from 'app/cms/carpricechecker/views/appointmentsSelect/Appointments.html';


class View extends TemplateView {
	get data() {
		var
			textArray = this._data || this.options.textArray
		;

		return {
			values: textArray.join(', '),
			count: textArray.length
		};
	}

	set data(value) {
		this._data = value;
	}

	get template() {
		return Template;
	}

	updateText(checkedValues) {
		this.data = checkedValues;
		this.render();
	}
}

export default View;
